import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import trasportApi from "../../api/trasportApi";
import { ShimmerTable } from "react-shimmer-effects";
import Main from "../layout/Main";
import Confirm from '../Confirm';
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";
import InfoPill from "../InfoPill";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import { useNavigate } from "react-router-dom";
// React Icons Starts Here
import { BsChevronRight } from "react-icons/bs";
//React Icons Ends here.


const SupplierList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [itemRec, setItem] = React.useState({});
  const [modalShowEditItem, setmodalShowEditItem] = React.useState(false);


  useEffect(() => {
    fetchAlItems();
  }, []);

  const fetchAlItems = () => {
    async function init() {
      const item = await trasportApi.fetchAllSupplier();
      if (item) {
        setBody(item);
      } else {
        setBody([]);
      }
    }
    init();
  }
  
  // Create table headers consisting of 4 columns.
  const header = [
    {
      title: "Supplier Name",
      prop: "name",
      isFilterable: true,
      cell: (row) => (
        <Link to={"/suppliers/" + row.id} state={row}>
          {row.name}
        </Link>
      ),
    },
    { title: "Price Deduction", prop: "address", isFilterable: true },
    { title: "Deduction Weight", prop: "email", isFilterable: true },
    { title: "Item Name", prop: "phone", isFilterable: true },
    { title: "Price Deduction", prop: "person_name", isFilterable: true },
        
  ];
  



  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const labels = {
    beforeSelect: " ",
  };

 

  const createSupplier = () => {
    navigate(`/suppliers/e`);
  };


  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.SupplierList}</title>
        </Helmet>
      </>
      
      <Row className="g-0">
        <Col lg={2} className="mx-2">
          <Link to="/home" style={{ "text-decoration": "none" }}>
            Home
          </Link>
          {/* <i className="fa-solid fa-chevron-right"></i>  */}
          <BsChevronRight/>
          Supplier List
        </Col>
        <Col lg={12} className="p-lg-4">
          {body ? (
            <DatatableWrapper
              body={body}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-center"
                >
                  <PaginationOptions labels={labels} />
                  <InfoPill left="Total" right={body?.length} />
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-md"
                    variant="primary"
                    onClick={() => createSupplier()}
                  >
                    New Supplier
                  </Button>
                </Col>
              </Row>

              <Table striped className="data-table">
                <TableHeader />

                <TableBody />
              </Table>

              <Pagination />
            </DatatableWrapper>
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Main>
  );
};
export default SupplierList;
